<span class="hover:underline cursor-pointer"
      [ngClass]="{'italic !text-light soft-label required': !$any(filter).value}"
      (click)="onValueClick()">
  {{$any(filter).value ? ($any(filter).value  | transform:(config?.params?.formatFn ?? defaultTransformFn)  | translate) : ('#APPLICATION.FILTER_AND_SORT.FILTER.LIST.PLACEHOLDER' | translate) }}
</span>
